import React from 'react'
import SettingSeoForm from '../components/setting/SettingsIpEditForm'

const SettingsUzanti = () => {
    return (
        <>
            <SettingSeoForm />
        </>
    )
}

export default SettingsUzanti